import React, { Component, Fragment } from 'react'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import history from './history'
import { actions } from './store'

import { Divisions, Dashboard, Channels, Confirm, Content, Login, Reset, ResetConfirm, Settings, Share, Users, Viewer, NotFound, Secure } from './views'
import { PrivateRoute, PublicRoute, Loader } from './components/Layout'
import { roles } from './constants'

const isGlobalDomain = window.location.href.indexOf('global.') > -1

class App extends Component {
  componentDidMount () {
    const { authenticate, getUser } = this.props

    if (authenticate()) {
      getUser()
    }
  }

  render () {
    const { isAuthenticated, user } = this.props

    if (isAuthenticated === null) {
      return null
    }

    if (isAuthenticated && user.info.role === null) {
      return <Loader />
    }

    return (
      <Fragment>
        <Router history={history}>
          <Switch>
            <PrivateRoute exact path='/admin' component={Dashboard} />
            <PrivateRoute path='/admin/divisions' component={Divisions} roles={[roles.GLOBAL_ADMIN]} />
            <PrivateRoute path='/admin/content' component={Content} roles={[roles.ORGANIZATION_ADMIN]} />
            <PrivateRoute path='/admin/channels' component={Channels} roles={[roles.ORGANIZATION_ADMIN]} />
            <PrivateRoute path='/admin/users' component={Users} roles={[roles.ORGANIZATION_ADMIN]} />
            <PrivateRoute path='/admin/settings' component={Settings} roles={[roles.ORGANIZATION_ADMIN, roles.GLOBAL_ADMIN]} />
            <PublicRoute exact path='/login' component={isGlobalDomain ? Secure : Login} />
            <PublicRoute exact path='/secure' component={Secure} />
            <PublicRoute exact path='/reset' component={Reset} />

            <Route exact path='/reset/confirm/:token' component={ResetConfirm} />
            <Route exact path='/share/:token' component={Share} />
            <Route exact path='/login/confirm/:token' component={Confirm} />
            <Route exact path='/' render={() => <Redirect to='/login' />} />
            <Route exact path='/viewer/:token' component={Viewer} />
            <Route path='*' component={NotFound} />
          </Switch>
        </Router>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.user
})

const mapDispatchToProps = dispatch => bindActionCreators({
  authenticate: actions.auth.authenticate,
  getUser: actions.user.getUser
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)



// WEBPACK FOOTER //
// ./src/App.jsx